module.exports = __webpack_public_path__ + "static/media/thewest_covidtracker-lg.0ebbecf3.png";